(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-the-makers-map"] && !Shopify.designMode) return;
  try {
    
/** code by squarestylist.com — standoutshopify.com **/
class SqshMakerMap extends HTMLElement {
  connectedCallback() {
    this.markers = Array.from(this.querySelectorAll('.sqsh-makers__marker'));
    this.markers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle(btn);
      });
    });

    this._onDocClick = (e) => {
      if (!this.contains(e.target)) this.closeAll();
    };
    this._onKey = (e) => {
      if (e.key === 'Escape') {
        const open = this.querySelector('.sqsh-makers__pin.is-open');
        this.closeAll();
        if (open) {
          const marker = open.querySelector('.sqsh-makers__marker');
          if (marker) marker.focus();
        }
      }
    };
    document.addEventListener('click', this._onDocClick);
    this.addEventListener('keydown', this._onKey);
  }

  toggle(btn) {
    const pin = btn.closest('.sqsh-makers__pin');
    if (!pin) return;
    const isOpen = pin.classList.contains('is-open');
    this.closeAll();
    if (!isOpen) {
      pin.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  closeAll() {
    this.querySelectorAll('.sqsh-makers__pin.is-open').forEach((pin) => {
      pin.classList.remove('is-open');
      const marker = pin.querySelector('.sqsh-makers__marker');
      if (marker) marker.setAttribute('aria-expanded', 'false');
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
  }
}

if (!customElements.get('sqsh-maker-map')) {
  customElements.define('sqsh-maker-map', SqshMakerMap);
}

  } catch(e) { console.error(e); }
})();
})();
